import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core'
import {NbDialogService} from '@nebular/theme'
import {PaymentComponent} from '../components/payment/payment.component'
import {AuthService} from '../auth.service'
import {PaymentService} from '../payment.service'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [PaymentService]
})
export class HomeComponent implements OnInit {
  constructor(
    private dialogService: NbDialogService,
    public auth: AuthService,
    private paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.auth.user$.subscribe(user => {
      if (user && (!user.userType || user.endSuscription == new Date())) {
        //this.open()
      }
    })
  }
}
